export default __webpack_public_path__ + "static/media/planet.c1cd168a.png";